import { FOLHA_PONTO_FULL_ACCESS } from '../constants/modules';
import { hasModuleConfiguration } from './moduleConfigurationPermission';

/**
 * Quem pode acessar /v2/relatorio-jornada (menu + tela).
 * Mesmo acesso total da Folha de Ponto — não há flag própria do relatório.
 */
export function canViewJornadaCompliance({ authData, moduleConfigurations }) {
  return hasModuleConfiguration(moduleConfigurations, authData, FOLHA_PONTO_FULL_ACCESS);
}
